import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SouthIcon(props: IconProps) {
    return <Icon {...props} iconKey={"south"}/>
}
